import axios from "axios"
import router from '@/router'
import Cookies from "js-cookie";
import {main_domain} from '@/config/sites'

const API_URL = `${process.env.VUE_APP_ASK_API_URL}/api/`;

export default {

    async getNewAccessToken (refreshToken){

      try {

        const response = await axios.post(API_URL + 'auth/refresh-token', {
          refreshToken: refreshToken,
          cookie: Cookies.get('google_access_token')
        })
        
        let oldUser = JSON.parse(atob(localStorage.getItem('user')));
        let newUser = response.data

        newUser.refreshToken = oldUser.refreshToken
        localStorage.setItem('user', btoa(JSON.stringify(newUser)))
        
        Cookies.set(
          'google_access_token', 
          JSON.stringify(
            {
              "token":`${newUser.accessToken}`,
              "refreshToken":`${newUser.refreshToken}`,
              "role":"admin",
              "area":"agf",
              "source":"google",
              "validate_agenzie": `${newUser.user[0].validate_agenzie ?? ''}`,
              "swo_recovery": newUser.user[0].swo_recovery,
              "can_access_ask_technology": response.data.user[0].can_access_ask_technology
            }
          ),
          { domain: `${main_domain.cookie}`,
            expires: 1 // 1 day
          }
        )
        
      } catch (err) {
        console.log(err)
        localStorage.removeItem('user');
        router.push('/login')
      }
      
    }
}
